import React from "react";

const ProductDetailPage = () => {
  return <div>ProductDetailPage</div>;
};

export default ProductDetailPage;
